import { IonPage } from '@ionic/react';
import styled from 'styled-components';

export const PaywallV5Styles = styled(IonPage)`
  ion-content {
    --background: #000;
    --padding-top: 72px;
    z-index: 0;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        180deg,
        #08140a 0%,
        #000000 50%,
        #0b0a22 100%
      );
      z-index: 1;
      pointer-events: none;
    }

    &::part(scroll) {
      margin: 0;
      padding: 0;
      z-index: 2;
    }
  }
`;
